<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="viewActionQueue">

    <p-confirmDialog  key="cd5" #cd5>
        <ng-template pTemplate="footer">
            <button (click)="cd5.reject()" class="btn btn-basic" type="button">No</button>
            <button (click)="cd5.accept()" class="btn btn-success" type="button">Yes</button>
            <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
        </ng-template>
    </p-confirmDialog>

    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">View or Modify Queue '{{ actionQueue.name }}'</h5>
        <button
            (click)="bsModalRef.hide()"
            class="ms-auto fas fa-times" type="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
        </button>
    </div>

    <div class="modal-body" style="padding: 0px; background-color: white; padding: 5px;">
    
        <tabset sty>  
            <tab heading="Waiting Queue ({{ actionQueue.queuedWaiting.length }})" active="true" class="tabset">
                <div style="margin-top: 2px; display: block; width: 100%;">
                    <p-table #EventsActionsTable [columns]="QueuedWaitingCols" [value]="actionQueue.queuedWaiting" [scrollable]="true" scrollHeight="25em" (onRowReorder)="onQueueReorder($event)">
                        <ng-template let-columns pTemplate="header">
                            <tr>
                                <th *ngFor="let col of columns" 
                                    [ngStyle]="{'width': col.width}" 
                                    style="background-color: var(--kig-section-header-bg); flex: none;" 
                                    [ngClass]="{'text-center': col.header == 'Cancel' || col.header == 'Run Now' || col.header == 'Reorder'}">
                                    {{col.header}}
                                </th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-rowData let-index="rowIndex"let-columns="columns" let-i="i" class="data-acquisition">
                            <tr [pReorderableRow]="index" style="height: 30px;">
                                <td [ngStyle]="{'width': columns[0].width, 'color': rowData.statusFontColor, 'background-color': rowData.statusBgColor}" style="flex: none; border-width: 0px;">
                                    {{ rowData.status }}
                                </td>

                                <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                                    {{ rowData.isManual ? 'M' : '' }}
                                </td>

                                <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                                    {{ rowData.eventName }}
                                </td>

                                <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                                    {{ rowData.actionType }}
                                </td>

                                <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
                                    {{ rowData.createdDate | date:'MMM d, h:mm a' }} ({{ rowData.waitingMinutesInQueue | number:'1.1-1' }})
                                </td>

                                <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;">
                                    {{ rowData.runByDate | date:'MMM d, h:mm a' }}
                                </td>

                                <td [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px;">
                                    <div *ngIf="rowData.status.toLowerCase() != 'done'" class="text-center" (click)="cancelQueueItem(rowData)" style="cursor: pointer;"> 
                                        <i class="fa-solid fa-ban" style="color:#c8102e;"></i>
                                    </div>
                                </td>

                                <td [ngStyle]="{'width': columns[7].width}" style="flex: none; border-width: 0px;">
                                    <div *ngIf="rowData.status.toLowerCase() == 'waiting'" class="text-center" (click)="executeQueueItem(rowData)" style="cursor: pointer;">
                                        <i class="fa-solid fa-arrow-up-from-bracket" style="color:#64a70b;"></i>
                                    </div>
                                </td>

                                <td [ngStyle]="{'width': columns[8].width}" style="flex: none; border-width: 0px;">
                                    <div *ngIf="rowData.status.toLowerCase() == 'waiting'" class="text-center" (click)="reorderQueueItem(rowData)" style="cursor: pointer;">
                                        <span class="pi pi-bars" pReorderableRowHandle></span>
                                    </div>
                                </td>
                        </ng-template>
                    </p-table>
                </div>
            </tab>

            <tab heading="Recent History ( Active={{ actionQueue.queuedActive }}, Total={{ actionQueue.queuedHistory.length }} )" class="tabset">
                <div style="margin-top: 2px; display: block; width: 100%;">
                    <p-table #EventsActionsTable [columns]="QueuedHistoryCols" [value]="actionQueue.queuedHistory" [scrollable]="true" scrollHeight="25em">
                        <ng-template let-columns pTemplate="header">
                            <tr>
                                <th *ngFor="let col of columns" 
                                    [ngStyle]="{'width': col.width}" 
                                    style="background-color: var(--kig-section-header-bg); flex: none;" 
                                    [ngClass]="{'text-center': col.header == 'QTime' || col.header == 'Revert' || col.header == 'Status'}">
                                    {{col.header}}
                                </th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="i" class="data-acquisition">
                            <tr style="height: 30px;">
                                <td [ngStyle]="{'width': columns[0].width, 'color': rowData.statusFontColor, 'background-color': rowData.statusBgColor}" style="flex: none; border-width: 0px;" class="text-center">
                                    {{ rowData.status }}
                                </td>

                                <td [ngStyle]="{'width': columns[1].width, 'color': rowData.ruleUsedFontColor, 'background-color': rowData.ruleUsedBgColor}" style="flex: none; border-width: 0px;">
                                    {{ rowData.ruleUsed }}
                                </td>

                                <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                                    {{ rowData.isManual ? 'M' : '' }}
                                </td>

                                <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                                    {{ rowData.eventName }}
                                </td>

                                <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
                                    {{ rowData.actionType }}
                                </td>

                                <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;" class="css-tooltip" [attr.tooltip-data]="getCreatedDateTooltip(rowData)">
                                    {{ rowData.modifiedDate | date : 'medium' }}
                                </td>

                                <td [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px;" class="text-center">
                                    {{ rowData.totalMinutesInQueue | number:'1.1-1' }}
                                </td>

                                <td [ngStyle]="{'width': columns[7].width}" style="flex: none; border-width: 0px;" class="text-center">
                                    <div *ngIf="rowData.status.toLowerCase() == 'canceled'" class="text-center" (click)="restoreCanceledItem(rowData)" style="cursor: pointer;">
                                        <i class="fa-solid fa-clock-rotate-left" style="color:#64a70b;"></i>
                                    </div>
                                </td>
                        </ng-template>
                    </p-table>
                </div>
            </tab>
        </tabset>
    </div>
</div>


